import React from "react";

const Img = ({ ...props }) => {
  return <img {...props} alt="" />;
};

export default Img;
